import { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";

type BillingPeriod = "monthly" | "yearly";

interface PricingBillingState {
  billingPeriod: BillingPeriod;
  setBillingPeriod: (period: BillingPeriod) => void;
}

const PricingBillingContext = createContext<PricingBillingState | null>(null);

interface PricingBillingProviderProps {
  children: ReactNode;
  defaultBilling?: BillingPeriod;
}

export const PricingBillingProvider = ({
  children,
  defaultBilling = "monthly",
}: PricingBillingProviderProps) => {
  const [billingPeriod, setBillingPeriod] =
    useState<BillingPeriod>(defaultBilling);

  return (
    <PricingBillingContext.Provider value={{ billingPeriod, setBillingPeriod }}>
      {children}
    </PricingBillingContext.Provider>
  );
};

export const usePricingBilling = (): PricingBillingState | null => {
  return useContext(PricingBillingContext);
};
